// extracted by mini-css-extract-plugin
export default {"home":"Home_home__9Ke73","info":"Home_info__ycGAZ","text":"Home_text__bwQM6","offer":"Home_offer__2zsCl"};